import { Column } from '../../components/Table/Table';

export const Columns = (t): Column[] => [
    { id: 'referenceText', label: t('Languages.detail.table-col-1') },
    { id: 'translatedText', label: t('Languages.detail.table-col-2') },
    { id: 'comment', label: t('Languages.detail.table-col-3') },
];
